import type { HTMLComponent } from "@commercekit/react";

const WvPageLoader: HTMLComponent<{
  loading?: boolean;
  loadingText?: string;
}> = ({ loading, loadingText }) =>
  loading ? (
    <div className="page-loader-wrapper">
      <div className="loader"></div>
      <div className="loading-text">{loadingText}</div>
    </div>
  ) : null;

export default WvPageLoader;
